import { render, staticRenderFns } from "./ReviewBlock.vue?vue&type=template&id=b3db81fe&scoped=true"
import script from "./ReviewBlock.vue?vue&type=script&lang=js"
export * from "./ReviewBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3db81fe",
  null
  
)

export default component.exports